/* @flow */
import * as React from 'react';
import LayerTrigger from 'components/LayerTrigger';
import AddParticipantModal from 'chat/components/AddParticipantModal';
import SettingsStore from 'stores/SettingsStore';
import ModalTrigger from 'components/ModalTrigger';
import Tooltip from 'components/Tooltip';
import Chat from 'entities/Chat';

type Props = {
  children?: (disabled: boolean) => void,
  onAddParticipants: () => void,
  chat: Chat,
};

class ChatAddParticipant extends React.Component<Props> {
  getAddParticipantModal() {
    return (
      // $FlowFixMe onRequestHide will be provided by ModalTrigger
      <AddParticipantModal
        chat={this.props.chat}
        onAddParticipants={this.props.onAddParticipants}
      />
    );
  }

  render() {
    const { chat } = this.props;

    if (!chat.canAdd()) {
      return null;
    }

    const disabled = chat.hasReachedParticipantNumberLimit();
    const wrapper = (
      <ModalTrigger modal={this.getAddParticipantModal()}>
        {this.props.children && this.props.children(disabled)}
      </ModalTrigger>
    );

    if (!disabled) {
      return wrapper;
    }

    const chatMembersLimit = SettingsStore.getChatMembersLimit();
    const tooltip = (
      <Tooltip>
        <span>Only {chatMembersLimit} people can participate in a conversation.</span>
      </Tooltip>
    );

    return (
      <LayerTrigger ref="tooltipTrigger" layer={tooltip} placement="left">
        {wrapper}
      </LayerTrigger>
    );
  }
}

export default ChatAddParticipant;
